import React from "react";
import PaymentSummary from "src/business-types/laundry/modules/home/Payment/components/PaymentSummary";
// import PaymentDetails from "./components/PaymentDetails";
// import PaymentActions from "./components/PaymentActions";
import Payment from "src/business-types/laundry/modules/home/Payment/Payment";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import { PaymentProps } from ".././Payment/types/payment";
import { useOrderProcessing } from "src/business-types/laundry/modules/home/Payment/hooks/useOrderProcessing";
import Done from "../Done/Done";
import { useUser } from "src/shared/context/UserContext";

const PayLater: React.FC<PaymentProps> = ({ cartId, backHome, backHomepay, editedAmounts }) => {
  const {
    cartProducts,
    customer,
    cartLoading,
    backToPayment,
    setBackToPayment,
    paymentSuccess,
    orderId,
    currentTime,
    roundAmount,
    handleOrderSuccess,
    buttonLoading,
  } = useOrderProcessing(cartId, editedAmounts);
  const { userConfigration } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);


  if (backToPayment) return <Payment cartId={cartId} backHomepay={backHomepay} backHome={backHome} editedAmounts={editedAmounts} />;
  if (paymentSuccess) return <Done orderid={orderId} onFinish={() => backHomepay("done")} customer={customer} />;
  // if (cartLoading || customerLoading) return <LoadingScreen />;

  

  return (
    <ModalWrapper
      title='Payment summary'
      // useTheme={true}
      onClose={() => backHome("false")}
      showBackButton
      onBack={() => setBackToPayment(true)}
      className='min-w-[480px] text-center'
      width='max-w-xl w-full'
      positionClass='top-0 left-0 right-0 mt-10 h-full'
    >
      <PaymentSummary
        products={cartProducts}
        customer={customer}
        paymentMethod='Buy on Credit'
        receivedAmount={0}
        showBalance={true}
        currentTime={currentTime}
        onAmountChange={() => {}}
        onToggleBalance={() => {}}
        roundAmount={roundAmount}
        onCancel={() => backHome("false")}
        onComplete={() => handleOrderSuccess("Buy on Credit")}
        isLoading={cartLoading || !customer}
        backHome={backHome}
        buttonLoading={buttonLoading}
        deliveryFeeEnabled={deliveryFeeEnabled}
      />
    </ModalWrapper>
  );
};

export default PayLater;
